<script lang="ts">
    import route from "@/Util/routes";
    import { Accordion } from "@/Common";
    import { createSectionSave } from "@/Util/utils";
    import { defaultCalSettingsForPlans, type CalendarSettings } from "@/Common/constants";
    import { RadioGroup, RadioGroupItem } from "@/lib/components/ui/radio-group";
    import Label from "@/lib/components/ui/label/label.svelte";

    export let alwaysOpen = false
    export let cal_settings: CalendarSettings
    let classNames = "";
    export { classNames as class };

    // set default
    $: if (!cal_settings.durability_metric) cal_settings.durability_metric = defaultCalSettingsForPlans.durability_metric

    function getBody(){
        return {
            durability_metric: cal_settings.durability_metric,
        }
    }

    const postCalendarSettings = route('CalendarController@saveCalendarSettings');
    // Only what has been edited is saved (createSectionSave)
    const section = createSectionSave(postCalendarSettings, getBody, "Durability Metric could not be saved.")
    const { saved } = section
    // What the server has: taken when the settings are loaded (a new object), not as they are edited (in place). Before
    // changed below: Svelte runs these in order, and changed must compare with what was just taken
    let loaded = null
    $: if (cal_settings && cal_settings !== loaded) { loaded = cal_settings; section.markSaved() }
    // Whether it has been edited since it was loaded or last saved, for the page's Save button
    export let changed = false
    $: changed = section.isChanged($saved, cal_settings)
    export const submitHandler = section.submit
</script>

<div class={classNames}>
    <Accordion {alwaysOpen} class="py-2 px-4 border border-solid border-black/10 rounded">
        <div slot="trigger" class="text-left {alwaysOpen ? '' : 'text-slate-600'}">Durability Metric</div>
        <div slot="content" class="px-1 py-2 twp flex flex-col">

            {#if cal_settings}
                <span class="mb-2 text-md">
                    Choose the desired method for calculating durability:
                    <a href="https://www.baronbiosys.com/glossary/durability" target="_help">
                        <div class="tooltip-icon">
                            <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
                        </div>
                    </a>
                </span>
                <RadioGroup bind:value={cal_settings.durability_metric}>
                    <div class="flex items-center space-x-2">
                        <RadioGroupItem value="total_work" id="durability-option-0"></RadioGroupItem>
                        <Label class="mb-0 font-normal" for="durability-option-0">Total Work</Label>
                    </div>
                    <div class="flex items-center space-x-2">
                        <RadioGroupItem value="above_threshold" id="durability-option-1"></RadioGroupItem>
                        <Label class="mb-0 font-normal" for="durability-option-1">Work Above LTP</Label>
                    </div>
                    <div class="flex items-center space-x-2">
                        <RadioGroupItem value="carbs_used" id="durability-option-2"></RadioGroupItem>
                        <Label class="mb-0 font-normal" for="durability-option-2">Carbs Depleted</Label>
                    </div>
                </RadioGroup>
            {:else}
                <div class="text-slate-600 text-center">Loading...</div>
            {/if}

        </div>
    </Accordion>
</div>

<style>
    .yellow-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: absolute;
        top: 3px;
        right: calc(50% - 10px);
        background-color: rgb(255, 167, 0);
    }

    .this-grid {
        display: grid;
        grid-template-columns: max-content auto max-content;
        grid-auto-flow: row;
        gap: 0.25rem;
        align-items: center;
    }
</style>